import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { BannerAdsState } from "./banner-ads.type";
import { BannerAds } from "@app/types";

const initialState: BannerAdsState = {
  list: [],
  errorMessage: "",
};

const bannerAdsSlice = createSlice({
  name: "@bannerAds",
  initialState,
  reducers: {
    storeBannerAds(state, action: PayloadAction<BannerAds[]>) {
      state.list = action.payload;
    },
    setBannerAdsErrorMessage(state, action: PayloadAction<string>) {
      state.errorMessage = action.payload;
    },
    clearBannerAds: () => initialState,
  },
});

export const { storeBannerAds, setBannerAdsErrorMessage, clearBannerAds } =
  bannerAdsSlice.actions;

export default bannerAdsSlice.reducer;
